<template>
    <div class="bg-white shadow-lg rounded-md border w-96" id="job_alert_popup">
        <div class="flex justify-end p-2 bg-gray-50">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-7 h-7 cursor-pointer"
                @click="closeModal"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
            </svg>
        </div>
        <div
            class="px-4 pb-4 text-center flex items-center bg-gray-50 border-b"
        >
            <svg
                fill="#3e4cb6"
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 960.789 960.789"
                xml:space="preserve"
                stroke="#3e4cb6"
                class="h-28 w-28"
            >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                    <g>
                        <g>
                            <g>
                                <path
                                    d="M99.336,960.789h446.061c44.185,0,80-35.816,80-80V590.973h-45.463l-28.59,14.131v172.13H93.39V67.399h457.952v61.197 h74.055V80c0-44.183-35.817-80-80-80H99.336c-44.183,0-80,35.817-80,80v800.791C19.336,924.973,55.153,960.789,99.336,960.789z M322.366,816.41c26.965,0,48.824,21.858,48.824,48.824c0,26.965-21.859,48.823-48.824,48.823 c-26.965,0-48.824-21.858-48.824-48.823C273.542,838.269,295.401,816.41,322.366,816.41z"
                                ></path>
                                <path
                                    d="M815.795,324.56c0-11.168-7.523-15.727-23.25-15.727H776.59v33.963h15.727 C808.727,342.796,815.795,335.73,815.795,324.56z"
                                ></path>
                                <path
                                    d="M823.088,385.193c0-12.994-9.117-18.691-27.58-18.691H776.59v38.977h18.918 C813.742,405.478,823.088,398.64,823.088,385.193z"
                                ></path>
                                <path
                                    d="M551.342,159.596h-86.051c-45.607,0-82.581,36.973-82.581,82.581v147.067v88.147v126.637 c0,17.94,14.722,31.008,30.979,31.008c4.547,0,9.214-1.023,13.713-3.246l123.941-61.266l21.347-10.554h52.709h233.475 c45.606,0,82.58-36.973,82.58-82.581V242.177c0-45.608-36.974-82.581-82.58-82.581H625.396H551.342L551.342,159.596z M552.768,382.001c0,5.092-0.477,10.013-1.426,14.674c-4.404,21.627-19.211,37.522-46.213,37.522 c-22.566,0-37.61-8.891-47.868-26.896l22.794-16.867c5.471,10.029,13.221,14.813,20.742,14.813 c12.082,0,18.463-6.153,18.463-25.983v-96.416h32.082h1.426V382.001z M743.082,282.849h50.83 c30.771,0,54.703,8.434,54.703,36.926c0,13.219-7.521,27.58-24.845,32.139v0.912c21.197,3.875,32.14,15.043,32.14,34.873 c0,30.316-25.527,43.765-57.668,43.765h-55.16V282.849L743.082,282.849z M647.582,280.112c40.117,0,67.471,28.037,67.471,76.359 c0,48.551-27.354,77.727-67.471,77.727c-7.937,0-15.361-1.159-22.187-3.367c-27.672-8.951-45.282-35.412-45.282-74.359 c0-38.947,17.61-64.528,45.282-73.132C632.221,281.218,639.646,280.112,647.582,280.112z"
                                ></path>
                                <path
                                    d="M614.531,356.472c0,16.54,3.922,29.714,10.864,38.184c5.591,6.821,13.138,10.595,22.187,10.595 c20.287,0,33.053-18.919,33.053-48.777c0-29.631-12.766-47.41-33.053-47.41c-9.049,0-16.596,3.546-22.187,10.096 C618.453,327.29,614.531,340.058,614.531,356.472z"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
            <div class="space-y-1">
                <h1 class="text-xl font-bold">
                    Not seeing what you're looking for ?
                </h1>
                <p class="font-bold text-xs tracking-wide text-gray-500">
                    We'll send driving job opportunities to you!
                </p>
            </div>
        </div>
        <div class="p-8">
            <form @submit.prevent="signUpForAlerts">
                <div class="grid grid-cols-1 gap-y-4 gap-x-4 sm:grid-cols-6">
                    <div class="col-span-6">
                        <label
                            for="first_name"
                            class="block text-xs font-medium text-gray-700"
                        >
                            First Name
                        </label>
                        <div class="mt-1 relative">
                            <input
                                @input="form.errors.name = ''"
                                v-model="form.name"
                                type="text"
                                name="first_name"
                                id="first_name"
                                class="shadow-sm block w-full sm:text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 border-gray-300"
                            />
                            <div
                                class="text-xs text-red-500 mt-1 tracking-wide"
                                v-if="form.errors.name"
                                v-text="form.errors.name"
                            ></div>
                        </div>
                    </div>

                    <div class="col-span-6">
                        <label
                            for="email"
                            class="block text-xs font-medium text-gray-700"
                        >
                            Email
                        </label>
                        <div class="mt-1 relative">
                            <input
                                @input="form.errors.email = ''"
                                v-model="form.email"
                                type="text"
                                name="email"
                                id="email"
                                class="shadow-sm block w-full sm:text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 border-gray-300"
                            />
                            <div
                                class="text-xs text-red-500 mt-1 tracking-wide"
                                v-if="form.errors.email"
                                v-text="form.errors.email"
                            ></div>
                        </div>
                    </div>

                    <div class="col-span-6">
                        <label
                            for="phone"
                            class="block text-xs font-medium text-gray-700"
                        >
                            Phone
                        </label>
                        <div class="mt-1 relative">
                            <input
                                @input="form.errors.phone_number = ''"
                                v-model="form.phone_number"
                                type="tel"
                                name="phone"
                                id="phone"
                                class="shadow-sm block w-full sm:text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 border-gray-300"
                            />
                            <div
                                class="text-xs text-red-500 mt-1 tracking-wide"
                                v-if="form.errors.phone_number"
                                v-text="form.errors.phone_number"
                            ></div>
                        </div>
                    </div>

                    <div class="col-span-6">
                        <label
                            for="zip"
                            class="block text-xs font-medium text-gray-700"
                        >
                            Zip code
                        </label>
                        <div class="mt-1 relative">
                            <input
                                @input="form.errors.zipcode = ''"
                                v-model="form.zipcode"
                                type="text"
                                name="zip"
                                id="zip"
                                autocomplete="postal-code"
                                class="shadow-sm block w-full sm:text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 border-gray-300"
                            />
                            <div
                                class="text-xs text-red-500 mt-1 tracking-wide"
                                v-if="form.errors.zipcode"
                                v-text="form.errors.zipcode"
                            ></div>
                        </div>
                    </div>
                </div>
                <div class="pt-8">
                    <span class="text-sm">
                        By signing up, you agree to receive alerts by email and
                        occasional text messages you can unsubscribe at any
                        time.
                    </span>
                </div>
                <div class="pt-8">
                    <button
                        type="submit"
                        class="w-1/2 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                        Get Alerts
                    </button>
                </div>
                <p class="mt-4">
                    <small
                        >This site is protected by reCAPTCHA and the Google
                        <a
                            class="underline font-medium"
                            href="https://policies.google.com/privacy"
                            >Privacy Policy</a
                        >
                        and
                        <a
                            class="underline font-medium"
                            href="https://policies.google.com/terms"
                            >Terms of Service</a
                        >
                        apply.
                    </small>
                </p>
            </form>
        </div>
    </div>
</template>
<script setup>
import { useForm } from "@inertiajs/inertia-vue3";

const emit = defineEmits(["closeModal"]);

const form = useForm({
    name: "",
    email: "",
    phone_number: "",
    zipcode: "",
});

const route = window.route;

const signUpForAlerts = async () => {
    form.post(route("receive.job.alerts"), {
        onSuccess: () => {
            form.reset();
            emit("closeModal");
        },
    });
};

function closeModal() {
    emit("closeModal");
}

window.addEventListener("mousedown", (e) => {
    const clickedEl = e.target;

    const job_alert_popup = document.getElementById("job_alert_popup");

    if (job_alert_popup?.contains(clickedEl)) {
    } else {
        emit("closeModal");
    }
});
</script>
<style></style>
